import * as jsxRuntime from "/repo/node_modules/preact/jsx-runtime/dist/jsxRuntime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment